import type { CreateAssignmentDTO } from "../../domain/contracts";
import type { BulkAssignmentSkip } from "../../domain/services/assignment-bulk-ui";

type BulkAssignmentPreviewProps = {
  performerNames: Map<string, string>;
  planned: CreateAssignmentDTO[];
  skipped?: BulkAssignmentSkip[];
  templateLabel?: string | null;
};

export function BulkAssignmentPreview({
  performerNames,
  planned,
  skipped = [],
  templateLabel,
}: BulkAssignmentPreviewProps) {
  if (planned.length === 0 && skipped.length === 0) {
    return null;
  }

  const byPerformer = new Map<string, CreateAssignmentDTO[]>();
  for (const item of planned) {
    const list = byPerformer.get(item.performerId) ?? [];
    list.push(item);
    byPerformer.set(item.performerId, list);
  }

  return (
    <div className="rounded-lg border bg-muted/20 p-3 text-sm">
      <p className="font-medium">
        ສະຫຼຸບກ່ອນບັນທຶກ
        {templateLabel ? ` — ${templateLabel}` : ""}
      </p>
      <p className="mt-1 text-muted-foreground text-xs">
        ຈະເພີ່ມ {planned.length} ລາຍການ
        {skipped.length > 0 ? ` (ຂ້າມ ${skipped.length} ລາຍການທີ່ຊ້ຳ)` : ""}
      </p>

      {byPerformer.size > 0 && (
        <ul className="mt-3 space-y-2">
          {[...byPerformer.entries()].map(([performerId, lines]) => (
            <li key={performerId}>
              <span className="font-medium">
                {performerNames.get(performerId) ?? performerId}
              </span>
              <span className="text-muted-foreground">
                {" "}
                — {lines.length} ບັນທັດ
              </span>
            </li>
          ))}
        </ul>
      )}

      {skipped.length > 0 && (
        <div className="mt-3 border-t pt-3">
          <p className="font-medium text-xs">ລາຍການທີ່ຈະຂ້າມ</p>
          <ul className="mt-1 space-y-1 text-muted-foreground text-xs">
            {skipped.slice(0, 6).map((item) => (
              <li
                key={[
                  item.input.performerId,
                  item.input.roleFeeKind,
                  item.input.lineKey ?? "default",
                  item.reason,
                ].join(":")}
              >
                {performerNames.get(item.input.performerId) ??
                  item.input.performerId}{" "}
                — {item.reason}
              </li>
            ))}
            {skipped.length > 6 ? (
              <li>… ແລະອີກ {skipped.length - 6} ລາຍການ</li>
            ) : null}
          </ul>
        </div>
      )}
    </div>
  );
}
